<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("Fnborders") }}</div>
      <div class="mt-3 mb-4">
        <div class="row">

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                name="selectcinema"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelect($event, Cinema, 'Cinema')"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="date"
                  v-on:click="date = null"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- @input="onGetTransactionList()" -->
                <label :class="date ? 'active' : ''">{{ $t("date") }}</label>
              </div>
            </div>
          </div>

         

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedBookingSource && selectedBookingSource.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("bookingsource", 1) }}</label
              >
              <b-dropdown
                :text="selectedBookingSource"
                name="selectbookingsource"
                id="selectbookingsource"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(booking, bookingIndex) in BookingSourceList"
                  :key="bookingIndex"
                  v-on:click="onSelect($event, booking, 'BookingSource')"
                  >{{ booking.bs_source }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedStatus && selectedStatus.length > 0 ? 'shift-up' : ''
                "
                >{{ $t("select") }} {{ $tc("status", 1) }}</label
              >
              <b-dropdown
                :text="selectedStatus"
                name
                id
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(status, statusIndex) in fnbOrderStatus"
                  :key="statusIndex"
                  v-on:click="onSelect($event, status, 'OrderStatus')"
                  >{{ status }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="GetTransactionList"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }} {{ $tc("report") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="transactionList && transactionList.length > 0"
        class="text-right mb-2"
      >
        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            Viewing&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp;
            <strong>{{ rows }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>{{ $tc("order") }} {{ $tc("code") }}</th>
              <th>
                {{ $tc("item") }} {{ $tc("name") }} ({{ $tc("quantity") }})
              </th>
              <th>{{ $tc("revenue") }}</th>
              <th>{{ $tc("bookingsource") }}</th>
              <th>
                {{ $tc("transaction") }} {{ $tc("date") }} & {{ $tc("time") }}
              </th>
              <th>{{ $tc("payment") }} {{ $tc("mode") }}</th>
              <th>{{ $tc("offer") }}</th>
              <th>
                {{ $tc("delivery") }} {{ $tc("date") }} & {{ $tc("time") }}
              </th>
              <th>{{ $tc("delivery") }} {{ $tc("status") }}</th>
              <th>{{ $tc("view") }} {{ $tc("details") }}</th>
            </tr>
          </thead>
          <tbody
            v-for="(fnbtrans, fnbtransIndex) in transactionList"
            :key="fnbtransIndex"
            class="sph-report"
          >
            <tr>
              <td>{{ fnbtrans.order_code }}</td>
              <td>{{ fnbtrans.item_with_quantity }}</td>
              <td>
                {{ fnbtrans.ft_currency_name }}
                {{ fnbtrans.ft_total_amount.toFixed(2) }}
              </td>
              <td>{{ fnbtrans.bs_source }}</td>
              <td>{{ dateParse(fnbtrans.ft_date_time) }}</td>
              <td>{{ fnbtrans.fat_payment_mode }}</td>

              <td>
                {{ fnbtrans.ft_offer_name ? fnbtrans.ft_offer_name : "-" }}
              </td>
              <td>{{ dateParse(fnbtrans.fnb_delivery_datetime) }}</td>
              <td>{{ fnbtrans.fat_status ? fnbtrans.fat_status : "-" }}</td>
              <td>
                <button @click="toDetails(fnbtrans)" class="btn-blue">
                  View More
                </button>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td v-if="transactionList.length == 0" colspan="10">
                <!-- <p class="text-center mb-0 h6">{{ $tc("NoRecords") }}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      transactionList: [],
      selectedCinema: "",
      cine_id: null,
      Cinemas: [],
      BookingSourceList: [],
      selectedBookingSource: "",
      bs_id: null,
      date: new Date(),
      fnbOrderStatus: ["All", "Pending", "Complete", "Delivered"],
      selectedStatus: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10"
    };
  },
  beforeMount() {
    this.getviewingnumber();

    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.onSelect(null, CinemaObj, "Cinema");
    // }
    this.GetBookingSources();
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelect(null, CinemaObj, "Cinema");
    //   }
    // }
  },
  methods: {
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetTransactionList();
      } else {
        this.currentPage = event;
        this.GetTransactionList();
      }
    },
    dateParse(date) {
      return moment(date).format("DD-MMM-YYYY HH:mm");
    },
    toDetails(object) {
      this.$router.push({
        name: "View F&B App Transaction",
        params: { ft_id: object.ft_id }
      });
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;

            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    GetBookingSources: function() {
      PosFnbService.BookingSources()
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              //   this.BookingSourceList = data.Records;
              data.Records.map(x => {
                if (x.bs_id == 7) this.BookingSourceList.push(x);
              });
              console.log(
                "this.BookingSourceList :>> ",
                this.BookingSourceList
              );
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelect: function(event, params, type) {
      if (type == "Cinema") {
        this.selectedCinema = params.cine_name;
        this.cine_id = params.cine_id;
        this.searchCinema = "";
        this.onSearchCinema();
        this.$store.dispatch("selectDropdownCinema", params);
      } else if (type == "BookingSource") {
        this.selectedBookingSource = params.bs_source;
        this.bs_id = params.bs_id;
      } else if (type == "OrderStatus") {
        this.selectedStatus = params;
      }
    },
    GetTransactionList: function() {
      // this.btenable = true;
      let loader = this.$loading.show();

      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        date: this.date,
        cinema_id: this.cine_id,
        bs_id: this.bs_id,
        selectedStatus: this.selectedStatus
      };
      PosFnbService.GetFnBAppTransactions(payload)
        .then(response => {
          this.btenable = false;
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.transactionList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.transactionList = [];
              this.$toasted.show("No Records Found");
            }
          } else {
            this.transactionList = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBOrdersComponent/FnbOrders.vue